import * as types from './mutation-types'

const mutations = {
    [types.SET_LOGS](state, data) {
        state.logs.push(data);
    },
    [types.CLEAR_LOGS](state) {
        state.logs = [];
    }
}

export default mutations;


// WEBPACK FOOTER //
// ./src/store/modules/logger/mutations.js